import React from 'react';
import { PriceDisplay } from './PriceDisplay';
import type { Subscription } from '../types';
interface PulseSubscriptionProps {
  subscription: Subscription;
  onUpgrade: () => void;
}
export const PulseSubscription = ({
  subscription,
  onUpgrade
}: PulseSubscriptionProps) => {
  return <div className="bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-97">
      <div className={`p-4 sm:p-6 relative ${['inactive', 'not_subscribed', 'incomplete_payment'].includes(subscription.status) ? 'bg-gradient-to-br from-[#EEF0F7] to-[#F5F6FA]' : ''}`} data-id="element-98">
        <div className={`flex flex-col`} data-id="element-99">
          <div className="flex flex-col sm:flex-row justify-between items-start mb-4 sm:mb-6" data-id="element-100">
            <div data-id="element-101">
              <h3 className="text-lg font-medium text-[#222E63]" data-id="element-102">
                Subscription
              </h3>
              <p className="text-sm text-gray-500 mt-1 flex items-center gap-1" data-id="element-103">
                Billed via{' '}
                <img src={subscription.billingSource.toLowerCase() === 'stripe' ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/oFWjQnHLsAzupPzuHWxeZz/download.png' : 'https://cdn.shopify.com/shopifycloud/web/assets/v1/favicon-default-6cbad9de243dbae3.ico'} alt={`${subscription.billingSource} logo`} className="w-4 h-4" data-id="element-104" />
                {subscription.billingSource.charAt(0).toUpperCase() + subscription.billingSource.slice(1)}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6" data-id="element-105">
            <div data-id="element-106">
              <div className="text-sm text-gray-500 mb-1" data-id="element-107">Billing Period</div>
              <div className="font-medium" data-id="element-108">Monthly</div>
            </div>
            <div data-id="element-109">
              <div className="text-sm text-gray-500 mb-1" data-id="element-110">Amount</div>
              <PriceDisplay amount={subscription.amount} status={subscription.status} data-id="element-111" />
            </div>
          </div>
        </div>
        {['inactive', 'not_subscribed', 'incomplete_payment'].includes(subscription.status) && <>
            <div className="absolute inset-0 bg-white/5 backdrop-blur-[2px]" data-id="element-112" />
            <div className="absolute inset-0 flex items-center justify-center sm:-translate-y-4 z-10" data-id="element-113">
              <button onClick={onUpgrade} className="w-full sm:w-auto mx-4 sm:mx-0 bg-[#566FFF] text-white px-8 py-3 rounded-md text-base font-medium hover:bg-[#4A5FE6] transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-transform" data-id="element-114">
                Upgrade
              </button>
            </div>
          </>}
      </div>
    </div>;
};